import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '@env/environment';
import {InventoryAdjustment} from '@app/domain/inventory-adjustment';
import {Page} from '@app/domain/page';
import {InventoryRecord} from '@app/domain/inventory-record';
import {TotalesInventario} from '@app/domain/totales-inventario';
import {Inventory} from '@app/domain/inventory';
import {ProductPresentationStock} from '@app/domain/product';
import {TotalInventario} from "@app/domain/total-inventario";
import {InventorySyncFixResult, InventorySyncIssue, InventorySyncSummary} from '@app/domain/inventory-sync-issue';

@Injectable({
    providedIn: 'root'
})
export class InventoryService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    findAllInventoryAdjustment(params): Observable<Page<InventoryAdjustment>> {
        return this.http.get<Page<InventoryAdjustment>>(`${this.baseUrl}/inventory-adjustment?${params}`);
    }

    saveInventoryAdjustment(model: InventoryAdjustment): Observable<InventoryAdjustment> {
        return this.http.post<InventoryAdjustment>(`${this.baseUrl}/inventory-adjustment`, model);
    }

    findAllProductsPage(params: string): Observable<Page<Inventory>> {
        return this.http.get<Page<Inventory>>(`${this.baseUrl}/inventory?${params}&compact=true`);
    }

    findTotales(params: string): Observable<TotalesInventario[]> {
        return this.http.get<TotalesInventario[]>(`${this.baseUrl}/inventory/operations/totales?${params}`);
    }

    findTotalStock(params: string): Observable<TotalInventario> {
        return this.http.get<TotalInventario>(`${this.baseUrl}/inventory/operations/total-stock?${params}`);
    }

    findAllLogsInventory(idInventory, params): Observable<Page<InventoryRecord>> {
        return this.http.get<Page<InventoryRecord>>(`${this.baseUrl}/inventory/${idInventory}?${params}`);
    }

    initByOffice(conStock): Observable<TotalesInventario[]> {
        return this.http.post<TotalesInventario[]>(`${this.baseUrl}/inventory/operations/iniciarPorPuntoVenta`, conStock);
    }

    initByOfficeByProduct(conStock): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/inventory/operations/iniciarInventarioProducto`, conStock);
    }

    /**
     * Crea las filas de inventario que falten en el punto de venta indicado.
     * Devuelve cuantas se crearon.
     */
    ensureInventories(idPuntoVenta: number): Observable<number> {
        return this.http.post<number>(`${this.baseUrl}/inventory/operations/ensure?idPuntoVenta=${idPuntoVenta}`, {});
    }

    /**
     * Cuantos productos con control de stock aun no tienen inventario en el punto de
     * venta indicado.
     */
    countMissingInventories(idPuntoVenta: number): Observable<number> {
        return this.http.get<number>(`${this.baseUrl}/inventory/operations/missing?idPuntoVenta=${idPuntoVenta}`);
    }

    /** Resumen de inventarios cuyo stock no cuadra con sus series/lotes. */
    findSyncIssuesSummary(idPuntoVenta?: number, clave?: string): Observable<InventorySyncSummary> {
        const partes = [];
        if (idPuntoVenta) {
            partes.push(`idPuntoVenta=${idPuntoVenta}`);
        }
        if (clave && clave.trim()) {
            partes.push(`clave=${encodeURIComponent(clave.trim())}`);
        }
        const params = partes.length ? `?${partes.join('&')}` : '';
        return this.http.get<InventorySyncSummary>(`${this.baseUrl}/inventory/sync-issues/summary${params}`);
    }

    findSyncIssues(params: string): Observable<Page<InventorySyncIssue>> {
        return this.http.get<Page<InventorySyncIssue>>(`${this.baseUrl}/inventory/sync-issues?${params}`);
    }

    /** Iguala el stock al conteo de series/lotes en los inventarios indicados. */
    fixSyncIssues(idsInventory: number[]): Observable<InventorySyncFixResult> {
        return this.http.post<InventorySyncFixResult>(`${this.baseUrl}/inventory/sync-issues/fix`, idsInventory);
    }


    countsProductEngaged(params: string): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/inventory/operations/product-engages?${params}`);
    }

    findByProductIds(productIds: number[], idPuntoVenta: number, incluirPresentaciones = false): Observable<Array<{
        id: number; inventario?: Inventory; presentacion?: ProductPresentationStock;
    }>> {
        const  options = {
            headers: {hideLoader: 'S'}
        };
        const presentaciones = incluirPresentaciones ? '&incluirPresentaciones=true' : '';
        return this.http.post<any[]>(
            `${this.baseUrl}/inventory/operations/by-product-ids?idPuntoVenta=${idPuntoVenta}${presentaciones}`, productIds, options);
    }

}
